var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_144508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_144508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 10L3.49805 8H1.74805L1.99805 7H3.74805L4.24805 5H2.24805L2.49805 4H4.49805L4.99805 2H5.99805L5.49805 4H7.49805L7.99805 2H8.99805L8.49805 4H10.248L9.99805 5H8.24805L7.74805 7H9.74805L9.49805 8H7.49805L6.99805 10H5.99805L6.49805 8H4.49805L3.99805 10H2.99805ZM4.74805 7H6.74805L7.24805 5H5.24805L4.74805 7Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.db7d2848c3dfc2be9d5b3a443965a89a.svg";
export { ForwardRef as ReactComponent };